import { render, staticRenderFns } from "./LevyCalculationPanelAdministrativeFee.vue?vue&type=template&id=50934ea4&"
import script from "./LevyCalculationPanelAdministrativeFee.vue?vue&type=script&lang=js&"
export * from "./LevyCalculationPanelAdministrativeFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports